import {
  Question,
  SAnswerTracker,
  Section,
  SurveyAnswerTracker,
} from '../types';
import { DEFAULT_BANNER_TYPE_QUESTION_TYPES } from '../constants';

function determineIfAnswered(qType: string, answer: unknown) {
  if (
    qType === 'multi_choice' ||
    qType === 'multi-choice' ||
    qType === 'checkbox'
  ) {
    return Array.isArray(answer) && answer.filter((a) => !!a)?.length > 0;
  }
  if (qType === 'bool') {
    // A bool question's answer is a real boolean, so `false` (a genuine "No")
    // is a valid, complete answer -- not "unanswered". Only null/undefined
    // means the question was skipped.
    return answer !== null && answer !== undefined;
  }
  return !!answer;
}

export function surveySectionAnswerTracker(
  sections: Section[],
): SAnswerTracker {
  if (!sections.length) {
    return null;
  }
  const _surveyAnswerTracker = new Map<string, SurveyAnswerTracker>();

  for (const section of sections) {
    if (section.type === 'section') {
      const _questions = section.children.filter(
        (q) =>
          q.type === 'question' &&
          !DEFAULT_BANNER_TYPE_QUESTION_TYPES.has(q.qtype),
      ) as Question[];
      const _answeredQuestions = _questions.filter(
        (q) =>
          determineIfAnswered(q.qtype, q.answer) &&
          q.collaboration_state !== 'todo_open',
      )?.length;
      _surveyAnswerTracker.set(section.id, {
        answeredQuestions: _answeredQuestions,
        totalQuestions: _questions.length,
      });
    }
  }
  return _surveyAnswerTracker;
}
